import {Button} from 'semantic-ui-react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  font-size: ${(props): string => props.theme.fontSizes.medium}!important;
  margin-bottom: 1rem !important;
`;

export default StyledButton;
